import { graphlib, layout } from "@dagrejs/dagre"

export const NODE_WIDTH = 260
/** Шапка и рамка блока «Старт»: у него нет счётчиков и превью. */
const START_BASE_HEIGHT = 68
/** Шапка, счётчики «Прошли / Застряли» и строка превью обычного блока. */
const BLOCK_BASE_HEIGHT = 179
const PORT_ROW_HEIGHT = 24
/** Строка «прикреплён файл» под превью: текст и нижний отступ. */
const ATTACHMENT_ROW_HEIGHT = 28

/** Высота блока на холсте; числа сняты с отрисованных карточек, чтобы новые блоки не ложились поверх. */
export function estimateNodeHeight(
	portCount: number,
	isStart = false,
	hasAttachment = false,
): number {
	return (
		(isStart ? START_BASE_HEIGHT : BLOCK_BASE_HEIGHT) +
		portCount * PORT_ROW_HEIGHT +
		(hasAttachment && !isStart ? ATTACHMENT_ROW_HEIGHT : 0)
	)
}

/**
 * Раскладка потока слева направо (dagre). Возвращает левый верхний угол
 * каждого блока: в таких координатах их хранит xyflow и api.
 */
export function autoLayout(
	nodes: { id: string; portCount: number; isStart?: boolean; hasAttachment?: boolean }[],
	edges: { source: string; target: string }[],
): Map<string, { x: number; y: number }> {
	const graph = new graphlib.Graph()
	graph.setGraph({ rankdir: "LR", nodesep: 40, ranksep: 100, marginx: 20, marginy: 20 })
	graph.setDefaultEdgeLabel(() => ({}))

	const ids = new Set(nodes.map((node) => node.id))
	for (const node of nodes) {
		graph.setNode(node.id, {
			width: NODE_WIDTH,
			height: estimateNodeHeight(node.portCount, node.isStart, node.hasAttachment),
		})
	}
	for (const edge of edges) {
		if (ids.has(edge.source) && ids.has(edge.target)) graph.setEdge(edge.source, edge.target)
	}
	layout(graph)

	const positions = new Map<string, { x: number; y: number }>()
	for (const node of nodes) {
		const placed = graph.node(node.id)
		positions.set(node.id, {
			x: Math.round(placed.x - placed.width / 2),
			y: Math.round(placed.y - placed.height / 2),
		})
	}
	return positions
}
